import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {PortalAuthService} from '@portal-commons/portal-auth.service';
import {KeycloakService} from '@portal-commons/providers/keycloak.service';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private auth: PortalAuthService,
    private keycloak: KeycloakService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && this.auth.isAuthenticatedValue()) {
          // Redirect to login page
          this.keycloak.login(this.router.url);
        }
        return throwError(error);
      }),
    );
  }
}
